var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "edit_svg__a",
    d: "M33.905 17.9a2.691 2.691 0 10-3.806-3.805L14.325 29.867l-.634 4.441 4.44-.635 15.774-15.772zM19.452 37.835l-7.993 1.144a2.153 2.153 0 01-2.437-2.436l1.141-7.994c.066-.462.28-.89.61-1.219l16.28-16.28a6.999 6.999 0 019.897 9.897l-16.28 16.28c-.33.329-.757.542-1.218.608z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "edit_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#edit_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#868686",
    mask: "url(#edit_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0zMy45MDUgMTcuOWEyLjY5MSAyLjY5MSAwIDEgMC0zLjgwNi0zLjgwNUwxNC4zMjUgMjkuODY3bC0uNjM0IDQuNDQxIDQuNDQtLjYzNSAxNS43NzQtMTUuNzcyek0xOS40NTIgMzcuODM1bC03Ljk5MyAxLjE0NGEyLjE1MyAyLjE1MyAwIDAgMS0yLjQzNy0yLjQzNmwxLjE0MS03Ljk5NGMuMDY2LS40NjIuMjgtLjg5LjYxLTEuMjE5bDE2LjI4LTE2LjI4YTYuOTk5IDYuOTk5IDAgMCAxIDkuODk3IDkuODk3bC0xNi4yOCAxNi4yOGMtLjMzLjMyOS0uNzU3LjU0Mi0xLjIxOC42MDh6Ii8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIGZpbGw9IiM4Njg2ODYiIG1hc2s9InVybCgjYikiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgEdit as ReactComponent };